import { useEffect, useRef, useState } from "react";
import { uepClient } from "uepClient";

const useMediaApi = (url, channel, isContentVisible) => {
  const cache = useRef({});
  const [mediaUrl, setMediaUrl] = useState("");
  const [isLoading, setLoading] = useState(true);
  useEffect(() => {
    const fetchMedia = () => {
      uepClient({ responseType: "blob" })
        .get(`/${channel.toLowerCase()}/media?mediaUrl=${url}&channel=${channel}`)
        .then((res) => {
          if (cache.current[url]) {
            const newData = cache.current[url];
            setMediaUrl(newData);
            setLoading(false);
          } else {
            const data = window.URL.createObjectURL(res.data);
            cache.current[url] = data;
            setMediaUrl(data);
            setLoading(false);
          }
        })
        .catch((err) => {
          console.error(`Failed to fetch media : ${url}`, err);
        });
    };
    if (isContentVisible && url) {
      fetchMedia();
    }
  }, [url, isContentVisible]);

  return { isLoading, mediaUrl };
};

export default useMediaApi;
